import { Types } from '@src/app/core/models/configuration.model';
import angular from 'angular';

const componentOptions = {
    bindings: {
        model : '=',
        info : '=',
        containerForm: '=',
        importError: '=',
        modelForm: '=',
        dynamicprice: '='
    },
    controllerAs : 'ibSubscriptionModelsImportCtrl',
    templateUrl: ['SubscriptionModelsAppConstants', (SubscriptionModelsAppConstants: SubscriptionModelsAppConstant): string => `${SubscriptionModelsAppConstants.templatesRoute}ib-subscription-models-import-view.html`]
};
const componentInfo = {
    module: 'ib-subscription-models-configuration-form-module',
    selector: 'ibSubscriptionModelsImport',
    inject:['$timeout', 'CurrencyService', 'SubscriptionModelsAppConstants', '$filter', 'CommonsUtilService'],
    required: []
};
export class ibSubscriptionModelsImport implements ng.IController {

    private amountEvent : Types.amountEvent;
    private model : Types.FixedPrice;
    private modelForm: any;
    private info : any;
    private dynamicprice: string;
    private importError: boolean;
    private containerForm: any;
    private PHONE_CLEANER: string;
    private PRICE_INTEGER: RegExp;
    private MAX_LENGTH: number;
    private errorMessage: string;
    constructor (private $timeout: ng.ITimeoutService,
        private CurrencyService: any, private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant,
        private $filter: angular.IFilterService, private CommonsUtilService: any) {

        this.PHONE_CLEANER = this.SubscriptionModelsAppConstants.PATTERNS.PHONE_CLEANER;
        this.PRICE_INTEGER = this.SubscriptionModelsAppConstants.PATTERNS.PRICE_INTEGER;
        this.MAX_LENGTH = String(this.info?.customPrice?.maxAmount).length;
        this.dynamicprice = null;
        this.amountEvent = {
            onblur : false,
            keydown : false,
            focused : false,
            customPrice : null,
            dynamicError : false,
            importError : false
        };
    }
    keydownInput = () => {
        const amountEventTemp = this.CommonsUtilService.keydownInput(this);
        this.amountEvent.onblur = amountEventTemp.onblur;
        this.amountEvent.keydown = amountEventTemp.keydown;
        this.importError = amountEventTemp.importError;
        this.$timeout( () => {
            this.amountEvent.keydown = false;
            this.amountEvent.onblur = this.amountEvent.customPrice !== null;
        }, 2000);
    };

    calculateDiscountPercentage = (dynamicprice) => {
        let percentage;
        if(dynamicprice >= this.info.customPrice.minAmount && dynamicprice <= this.info.customPrice.amounts[0]) {
            percentage = this.info.customPrice.discounts[0];
        }else if(dynamicprice >= this.info.customPrice.amounts[0] && dynamicprice <= this.info.customPrice.amounts[1]) {
            percentage = this.info.customPrice.discounts[1];
        }else if(dynamicprice >= this.info.customPrice.amounts[1] && dynamicprice <= this.info.customPrice.amounts[2]) {
            percentage = this.info.customPrice.discounts[2];
        }else if(dynamicprice >= this.info.customPrice.amounts[2] && dynamicprice <= this.info.customPrice.amounts[3]) {
            percentage = this.info.customPrice.discounts[3];
        } else if (dynamicprice >= this.info.customPrice.amounts[3] && dynamicprice <= this.info.customPrice.amounts[4]) {
            percentage = this.info.customPrice.discounts[4];
        }

        return percentage;
    };

    onChangeRadio = () :void =>{
        this.dynamicprice = undefined;
        this.amountEvent.customPrice = null;
        this.amountEvent.dynamicError =false;
        this.amountEvent.onblur = false;
        this.importError = false;
    };

    onChangeAction = () :void =>{
        const maxAmounNotNullOr0OrGreaterdynamicprice = (this.info?.customPrice?.maxAmount === null || this.info?.customPrice?.maxAmount === 0 || parseInt(this.dynamicprice) <= this.info?.customPrice?.maxAmount),
            minAmounNotNullOr0OrLessdynamicprice = (this.info?.customPrice?.minAmount === null || this.info?.customPrice?.minAmount === 0 || parseInt(this.dynamicprice) >= this.info?.customPrice?.minAmount),
            minAmountAndMaxAmountNotExist = !this.info?.customPrice?.minAmount && !this.info?.customPrice?.maxAmount,
            maxAmountNotNullOrGreater0 = (this.info?.customPrice?.maxAmount !== null || this.info?.customPrice?.maxAmount > 0),
            dinamicPriceGreaterMaxAmount = (parseInt(this.dynamicprice) > this.info?.customPrice?.maxAmount),
            minAmountNotNullOrGreater0 = (this.info?.customPrice?.minAmount !== null || this.info?.customPrice?.minAmount > 0),
            dinamicPriceLessMinAmount = (parseInt(this.dynamicprice) < this.info?.customPrice?.minAmount),
            minAmountAndMaxAmountExist = (this.info?.customPrice?.minAmount && this.info?.customPrice?.maxAmount),
            minAmountNotExistMaxAmountExist = (!this.info?.customPrice?.minAmount && this.info?.customPrice?.maxAmount),
            minAmountExistMaxAmountNotExist = (this.info?.customPrice?.minAmount && !this.info?.customPrice?.maxAmount);
        this.amountEvent.keydown = false;
        this.amountEvent.dynamicError = this.dynamicprice === undefined && this.containerForm.customAmount?.$viewValue &&
        this.containerForm.customAmount?.$viewValue!=='';

        if( ((maxAmountNotNullOrGreater0 && dinamicPriceGreaterMaxAmount) || (minAmountNotNullOrGreater0 && dinamicPriceLessMinAmount))) {
            if(minAmountAndMaxAmountExist) {
                this.errorMessage = this.$filter('translate')('SUBSCRIPTION_MODELS_IMPORT_ERROR_BETWEEN_DYNAMIC_PRICE').replace('XXX', this.info?.customPrice?.minAmount.toString()).replace('YYYY', this.info?.customPrice?.maxAmount.toString());
            }else if(minAmountNotExistMaxAmountExist) {
                this.errorMessage = this.$filter('translate')('SUBSCRIPTION_MODELS_IMPORT_ERROR_MAX_DYNAMIC_PRICE');
            }else if(minAmountExistMaxAmountNotExist) {
                this.errorMessage = this.$filter('translate')('SUBSCRIPTION_MODELS_IMPORT_ERROR_MIN_DYNAMIC_PRICE');
            }
            this.amountEvent.dynamicError =true;
            this.model = null;
            this.amountEvent.customPrice = null;
        } else if(this.dynamicprice && (maxAmounNotNullOr0OrGreaterdynamicprice || minAmounNotNullOr0OrLessdynamicprice || minAmountAndMaxAmountNotExist)) {
            this.amountEvent.onblur = true;
            this.info.customPrice.percentage = this.calculateDiscountPercentage(this.dynamicprice);
            this.amountEvent.customPrice  = parseInt(this.dynamicprice) - ( parseInt(this.dynamicprice) * (this.info.customPrice.percentage / 100));
            this.model = {
                amount: parseInt(this.dynamicprice),
                price:this.CurrencyService.formatPrice(
                    this.info.currency,
                    parseInt(this.dynamicprice),
                    false
                ),
                campaignId: this.info.customPrice.campaignId,
                name: '',
                discount: {
                    amount: this.amountEvent.customPrice,
                    percentage: this.info.customPrice.percentage === 0 ? null : this.info.customPrice.percentage,
                    price: this.CurrencyService.formatPrice(
                        this.info.currency,
                        this.amountEvent.customPrice,
                        true
                    )
                }
            };
        } else if((this.dynamicprice === undefined  || this.dynamicprice === null || this.dynamicprice ==='')  &&  this.amountEvent.customPrice !== null) {
            this.model = null;
            this.amountEvent.customPrice = null;
            this.amountEvent.dynamicError =false;
        }

    };

    resetFields = () :void=> {
        this.amountEvent = this.CommonsUtilService.resetFields(this.amountEvent);
        this.importError = this.amountEvent.importError;
    };

}
try {
    const mod = angular.module(componentInfo.module);
    ibSubscriptionModelsImport.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSubscriptionModelsImport })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibSubscriptionModelsImport.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSubscriptionModelsImport })
    );
}
